import styled from 'styled-components';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	lineHeight,
	minWidth,
	Text,
	TextAlign,
	TextElements,
	units,
} from '@calm-web/design-system';

export const Container = styled.div`
	max-width: 1000px;
	background-color: #f8f8f8;
	${lineHeight(FontSizes.xl)};
	${fontWeight(FontWeights.Light)};
	${fontSize(FontSizes.base)};
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
	margin: 0 auto;
	border-radius: 0;
	padding: ${units(4)};

	a {
		position: relative;
		${fontWeight(FontWeights.Demi)};
		color: #3478dd;
		padding-bottom: 1px;

		&:hover {
			bottom: 1px;
		}
	}

	${minWidth('desktop')} {
		margin-top: ${units(8)};
		margin-bottom: ${units(8)};
		border-radius: 16px;
		padding: ${units(4, 8)};
	}
`;

export const DocumentTitle = styled(Text).attrs({
	el: TextElements.H1,
	size: FontSizes['2xl'],
	weight: FontWeights.Light,
	align: TextAlign.Center,
})`
	margin-bottom: ${units(0.2)};
`;

export const LastUpdatedDate = styled.div`
	text-align: center;
	margin-bottom: ${units(8)};
`;
